var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"linkGraph"},[_c('div',{staticClass:"graphContainer"},[_c('div',{ref:"graphChartCompany",staticClass:"graphChartCompany"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }